import { render, staticRenderFns } from "./TableButtonsAssignMultipleParcels.vue?vue&type=template&id=7dc36c56&scoped=true&"
import script from "./TableButtonsAssignMultipleParcels.vue?vue&type=script&lang=js&"
export * from "./TableButtonsAssignMultipleParcels.vue?vue&type=script&lang=js&"
import style0 from "./TableButtonsAssignMultipleParcels.vue?vue&type=style&index=0&id=7dc36c56&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dc36c56",
  null
  
)

export default component.exports